// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1INIm";
export var profileImg = "styles-module--profileImg--1a_xd";
export var sectionTitle = "styles-module--sectionTitle--1C4aZ";
export var content = "styles-module--content--zq96b";
export var blockquoteWrapper = "styles-module--blockquoteWrapper--bKymx";
export var highlight = "styles-module--highlight--1gjNx";